import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${() => `${viewSizeCalculator(50)}`}; // 50rem
  margin: auto;
  gap: ${() => `${viewSizeCalculator(2.5)}`};
  animation: scaleIn 0.5s ease-out forwards;
  transform: scale(0.1);
  opacity: 0;

  @keyframes scaleIn {
    0% {
      transform: scale(0.1);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: ${() => `${viewSizeCalculator(50)}`}; // 50rem
    height: 100%;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;

export const Title = styled.p`
  font-family: Inter;
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1.1)}`};
  line-height: ${() => `${viewSizeCalculator(1.375)}`};
  color: #333333;
  text-align: center;
`;

export const Para = styled.p`
  font-family: Inter;
  font-weight: 400;
  font-size: ${() => `${viewSizeCalculator(1.1)}`};
  line-height: ${() => `${viewSizeCalculator(1.375)}`};
  color: #333333;
  text-align: center;
  margin-top: ${() => `${viewSizeCalculator(0.2)}`};
`;

export const Button = styled.button`
  border: ${() => `${viewSizeCalculator(1, true)} solid #333333`};
  outline: none;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem

  height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
  width: ${() => `${viewSizeCalculator(9.375)}`}; // 9.375rem

  padding: ${() => `${viewSizeCalculator(0.75)} ${viewSizeCalculator(0.5)} 
                       ${viewSizeCalculator(0.75)} ${viewSizeCalculator(0.5)}`};
  line-height: 100%;
  font-family: Inter;
  font-weight: 500;
  font-size: ${() => `${viewSizeCalculator(1)}`};
  color: #fff;
  background: #333333;
  text-align: center;
  margin-top: ${() => `${viewSizeCalculator(1)}`};

  cursor: pointer;
`;
